'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _beautifyNumber = require('../../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);

var _Contacts = require('../Contacts/Contacts');var _Contacts2 = _interopRequireDefault(_Contacts);

var _BasicInformation = require('./BasicInformation.scss');var styles = _interopRequireWildcard(_BasicInformation);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var currencies = {
  ILS: '₪',
  USD: '$',
  EUR: '€' };


var BasicInformation = function BasicInformation(_ref)





















{var isUnlimitedLeads = _ref.isUnlimitedLeads,scrollToForm = _ref.scrollToForm,neighborhood = _ref.neighborhood,house_number = _ref.house_number,country_name = _ref.country_name,street_name = _ref.street_name,phoneNumber = _ref.phoneNumber,exactPrice = _ref.exactPrice,apartments = _ref.apartments,translate = _ref.translate,city_name = _ref.city_name,isForeign = _ref.isForeign,buildings = _ref.buildings,minPrice = _ref.minPrice,isMobile = _ref.isMobile,currency = _ref.currency,floors = _ref.floors,locale = _ref.locale,logo = _ref.logo,name = _ref.name,id = _ref.id;
  var renderPrice = function renderPrice() {return (
      _react2.default.createElement('div', { className: styles.price },
        minPrice ?
        _react2.default.createElement('p', null,
          translate('from')) :

        '', (


        currencies[currency] || currencies.ILS) + ' ' + (0, _beautifyNumber2.default)(exactPrice || minPrice)));};



  return (
    _react2.default.createElement('div', { className: styles.wrapper },
      _react2.default.createElement('div', { className: styles.basicInformationWrapper, id: 'stickySection' },
        _react2.default.createElement('div', null,
          _react2.default.createElement('div', { className: styles.logoWrapper },
            _react2.default.createElement('img', { src: logo, alt: '' })),

          _react2.default.createElement('div', { className: styles.projectName },
            _react2.default.createElement('p', { className: styles.name }, name[locale] || name.he),
            renderPrice())),


        (apartments || floors || buildings) &&
        _react2.default.createElement('div', { className: styles.propertyInformation },
          floors &&
          _react2.default.createElement('div', null,
            _react2.default.createElement('p', { className: styles.count }, buildings),
            _react2.default.createElement('p', null, translate('addNewProject', 'buildings'))),


          buildings &&
          _react2.default.createElement('div', null,
            _react2.default.createElement('p', { className: styles.count }, floors),
            _react2.default.createElement('p', null, translate('addNewProject', 'floors'))),


          apartments &&
          _react2.default.createElement('div', null,
            _react2.default.createElement('p', { className: styles.count }, apartments),
            _react2.default.createElement('p', null, translate('addNewProject', 'apartments')))),




        isMobile &&
        _react2.default.createElement('div', { className: styles.addressWrapper },
          _react2.default.createElement('div', { className: styles.addressLine },
            _react2.default.createElement('p', { className: styles.streetName },
              street_name,
              house_number,
              (!neighborhood || neighborhood === city_name) && ',', '\xA0'),


            _react2.default.createElement('div', null,
              neighborhood &&
              neighborhood !== city_name &&
              _react2.default.createElement('div', null,
                neighborhood, ', \xA0'),



              _react2.default.createElement('div', null, city_name, isForeign && ', ' + country_name)))),




        _react2.default.createElement('div', { className: styles.contacts },
          _react2.default.createElement(_Contacts2.default, {
            isUnlimitedLeads: isUnlimitedLeads,
            translate: translate,
            phoneNumber: phoneNumber,
            isForeign: isForeign,
            id: id,
            scrollToForm: scrollToForm,
            isMobile: isMobile,
            locale: locale })))));





};

BasicInformation.propTypes = {
  isUnlimitedLeads: _propTypes2.default.bool,
  house_number: _propTypes2.default.string,
  neighborhood: _propTypes2.default.string,
  country_name: _propTypes2.default.string,
  street_name: _propTypes2.default.string,
  phoneNumber: _propTypes2.default.string,
  scrollToForm: _propTypes2.default.func,
  apartments: _propTypes2.default.string,
  exactPrice: _propTypes2.default.string,
  city_name: _propTypes2.default.string,
  buildings: _propTypes2.default.string,
  currency: _propTypes2.default.string,
  minPrice: _propTypes2.default.string,
  isForeign: _propTypes2.default.bool,
  translate: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  floors: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  logo: _propTypes2.default.string,
  name: _propTypes2.default.object,
  id: _propTypes2.default.string };exports.default =


BasicInformation;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectDetailedInfo/BasicInformation/BasicInformation.js
// module id = 2807
// module chunks = 0